enum ContractRefundStatusCode {
  OPEN = 'OPEN',
  PROCESSING = 'PROCESSING',
  APPROVED = 'APPROVED',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED',
}

export default ContractRefundStatusCode;
export type VerifyContractRefundStatusCode = Utils.VerifyExtends<
  Model.Enum.ContractRefundStatusCode,
  Utils.ValueOf<typeof ContractRefundStatusCode>
>;
